import { BrowserRouter, RootRoute } from 'routes';
import { useTheme } from 'hooks';
import {
	StyledEngineProvider,
	ThemeProvider,
	CssBaseline,
} from 'components/mui';
import NotificationBar from 'components/notificationBar/NotificationBar.jsx';
import { ErrorBoundary } from 'components';
import { ROUTE_BASE } from 'constants/routerPath';
import { LoadingProvider } from 'contextProviders/LoadingBackdropProvider';
import OnboardingTourProvider from 'components/onboarding/OnboardingTourProvider';
import TourRouteWatchers from 'components/onboarding/tour/TourRouteWatchers';
import LoadingBackdropGlobal from 'components/LoadingBackdropGlobal';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LoginModal from 'components/loginModal/LoginModal';
import { TicketTerminologyProvider } from 'containers/pages/CANpark/context/TicketTerminologyProvider';

const queryClient = new QueryClient();

function App() {
	const { muiTheme, themeMode } = useTheme();

	return (
		<ErrorBoundary>
			<main data-theme={themeMode}>
				<ThemeProvider theme={muiTheme}>
					<CssBaseline />
					<StyledEngineProvider injectFirst>
						<QueryClientProvider client={queryClient}>
							<TicketTerminologyProvider>
								<LoadingProvider>
									<OnboardingTourProvider>
										<BrowserRouter basename={ROUTE_BASE}>
											<TourRouteWatchers />
											<RootRoute />
										</BrowserRouter>
										<LoadingBackdropGlobal />
									</OnboardingTourProvider>
								</LoadingProvider>
							</TicketTerminologyProvider>
						</QueryClientProvider>
					</StyledEngineProvider>
				</ThemeProvider>
				<NotificationBar />
				<LoginModal />
			</main>
		</ErrorBoundary>
	);
}

export default App;
